import { Heading3 } from 'app/components/Typography';
import OstroChatAvatar from 'app/components/chatbot/OstroChatAvatar';
import useFetchLiveChat from 'app/hooks/fetch/useFetchLiveChat';
import { useConcierge } from 'app/modules/live-chat/hooks/useConcierge';
import { useTranslation } from 'react-i18next';

import NetworkStatusIndicator from './NetworkStatusIndicator';

const ConciergeInfo = () => {
  const { data } = useFetchLiveChat();
  const concierge = useConcierge();
  const { t } = useTranslation();

  const isOnline = data?.nurses_are_online ?? false;
  const avatar = concierge?.avatar;
  const title = concierge?.name || t('live_chat_online_title');
  const nextOnlineTime = data?.next_online_status_change_dt || new Date().toISOString();

  return (
    <div className="flex-grow flex items-center">
      <div className="flex gap-1 items-center whitespace-nowrap">
        {isOnline && avatar ? (
          <span className="mr-1">
            <OstroChatAvatar src={isOnline ? avatar : ''} />
          </span>
        ) : null}
        <Heading3
          id="ostro-live-chat-title"
          className="font-medium"
        >
          {isOnline ? title : t('live_chat_offline_title')}
        </Heading3>
        <NetworkStatusIndicator
          isOnline={isOnline}
          nextOnlineTime={nextOnlineTime}
        />
      </div>
    </div>
  );
};

export default ConciergeInfo;
